module.exports = __webpack_public_path__ + "static/media/c4.733cea17.jpg";